import { render, staticRenderFns } from "./BalancePayoneerHistoryHead.vue?vue&type=template&id=038f708f&scoped=true"
import script from "./BalancePayoneerHistoryHead.vue?vue&type=script&lang=js"
export * from "./BalancePayoneerHistoryHead.vue?vue&type=script&lang=js"
import style0 from "./BalancePayoneerHistoryHead.vue?vue&type=style&index=0&id=038f708f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f708f",
  null
  
)

export default component.exports